import React, { Component } from 'react';
import { css } from 'aphrodite';

import { ReportBox, Flexbox, Font, Text, ColorEnvironment } from './Styles'
import Image from './Image';
import PrimaryButton from './PrimaryButton';

import Locale from './models/Locale';

class EventReportCard extends Component {
  render() {
    let background = this.props.event.isWildcard? ColorEnvironment.inverse : ColorEnvironment.normal;
    return(
      <div className={css(Flexbox.column, Flexbox.axisStart, Flexbox.crossCenter)}>
        <div className={css(Flexbox.column, Flexbox.axisStart, Flexbox.crossCenter, ReportBox.container)}>
          <Image extraStyles={[ReportBox.topImage, background]} filename={this.props.event.iconFilename} />
          <div className={css(Font.largeHeading, Text.heading)}>{Locale.localized("Status Report")}</div>
          <div className={css(Font.heading, Flexbox.centeredItem, Text.heading)}>{Locale.localized("You were unprepared for:") + " " + this.props.event.hazard}</div>
          <div className={css(Flexbox.grow, Flexbox.centeredItem, Text.textBlock)}>
            {!!this.props.effectiveAction &&
              <p>{this.props.event.rationaleForAction(this.props.effectiveAction)}</p>
            }
            {!this.props.effectiveAction &&
              <p>{this.props.event.hint}</p>
            }
          </div>
          <div onClick={this.props.onComplete.bind(this)}>
            <PrimaryButton>{Locale.localized("Spin The Wheel")}</PrimaryButton>
          </div>
        </div>
      </div>
    );
  }
}

export default EventReportCard;



// WEBPACK FOOTER //
// ./src/EventReportCard.js